<template>
  <div v-if="$route.name == 'main'">
    <gnb-area></gnb-area>
    <router-view></router-view>
    <scroll-top></scroll-top>
    <footer-area></footer-area>
  </div>
  <div v-else-if="$route.meta.category">
    <gnb-area></gnb-area>
    <section id="container">
      <top-navigation></top-navigation>
      <div id="subPage">
        <left-menu></left-menu>
        <router-view></router-view>
      </div>
      <scroll-top></scroll-top>
    </section>
    <footer-area></footer-area>
  </div>
  <div v-else>
    <gnb-area></gnb-area>
    <router-view></router-view>
    <footer-area></footer-area>
  </div>
</template>

<script>
import GnbArea from '@/html/layout/GnbArea.vue';
import FooterArea from '@/html/layout/FooterArea.vue';
import TopNavigation from '@/components/TopNavigation.vue';
import LeftMenu from '@/components/LeftMenu.vue';
import ScrollTop from '@/components/ScrollTop.vue';

export default {
  data() {
    return {};
  },

  components: {
    GnbArea,
    FooterArea,
    TopNavigation,
    LeftMenu,
    ScrollTop,
  },
};
</script>
